import React from 'react';
import PropTypes from 'prop-types';

import WeddingEventFeatureUpsell from './WeddingEventFeatureUpsell';
import withModal from '../../../../../../components/global/modal/withModal';
import DismissButton from '../../../../../../components/global/DismissButton';

export const WEDDING_EVENT_FEATURE_UPSELL_MODAL =
  'modal/WEDDING_EVENT_FEATURE_UPSELL_MODAL';

const propTypes = {
  onClose: PropTypes.func,
  onRequestClose: PropTypes.func,
  actionProps: PropTypes.shape({
    featureId: PropTypes.string,
    onCheckoutSuccess: PropTypes.func,
    title: PropTypes.node,
    subtitle: PropTypes.node,
    illustration: PropTypes.node,
  }),
};

const WeddingEventFeatureUpsellModal = ({
  onRequestClose,
  onClose,
  actionProps: {
    featureId,
    onCheckoutSuccess,
    title,
    subtitle,
    illustration,
  } = {},
  ...props
}) => {
  return (
    <>
      <DismissButton
        onClick={() => {
          onClose?.();
          onRequestClose?.();
        }}
        className="wedding-event-purchase-dismiss"
      />
      <WeddingEventFeatureUpsell
        {...props}
        featureId={featureId}
        onCheckoutSuccess={onCheckoutSuccess}
        onClose={() => {
          onClose?.();
          onRequestClose?.();
        }}
        title={title}
        subtitle={subtitle}
        illustration={illustration}
      />
    </>
  );
};

WeddingEventFeatureUpsellModal.propTypes = propTypes;

export default withModal(WeddingEventFeatureUpsellModal, {
  name: WEDDING_EVENT_FEATURE_UPSELL_MODAL,
  className: 'wedding-event-purchase-modal wedding-event-feature-upsell-modal',
  overlayClassName: 'wedding-event-purchase-modal-overlay',
  size: 'md',
  dismissible: false,
});
